import React, { Suspense } from 'react';
import { Loader } from '@dekafvv/sharedfrontend';
import { Content } from 'components/Layout/Content';

const DataProtection = React.lazy(() => import('pages/DataProtection/DataProtection'));

export const dataProtection = {
    Component: Content,
    url: 'datenschutz',
    props: {
        children: <Suspense fallback={<Loader />}><DataProtection /></Suspense>,
    },
};
